// extracted by mini-css-extract-plugin
export var avatarBone = "_a-4";
export var buttonBone = "_a-3";
export var continueBone = "_a-a";
export var frame = "_a-1";
export var logoBone = "_a-2";
export var pickerGrid = "_a-d";
export var pitchBone = "_a-9";
export var productBone = "_a-8";
export var sectionBone = "_a-7";
export var shell = "_a-0";
export var skeletonPulse = "_a-b";
export var subtitleBone = "_a-6";
export var titleBone = "_a-5";
export var viewport = "_a-c";